<template>
  <b-modal
    v-model="dialog"
    hide-footer
    scrollable
    size="xl"
  >
    <template #modal-header="{}">
      <div id="scoreStructureRecords">
        <span class="hazard-name">{{ hazardName }}</span>
        for
        <span class="chemical-name">{{ chemical.name }}</span>
        (
        <b-link class="no-link-under">
          {{ chemical.casrn }}
          <v-icon>mdi-magnify</v-icon>
        </b-link>
        )
      </div>
      <b-popover
        target="scoreStructureRecords"
        triggers="hover"
      >
        <img
          :src="getStructureImageUrl(chemical, 150, 150)"
          alt=""
          class="t-img"
        />
      </b-popover>
      <b-form-input
        v-model="recordsTableFilter"
        type="text"
        class="mb-2 records-table-filter"
        placeholder="Filter table content by text"
      />
    </template>

    <ScoreRecordsTable
      :hazard-name="hazardName"
      :score-records="records"
      :score-structure="chemical"
    />
  </b-modal>
</template>
<script>
import ScoreRecordsTable from './ScoreRecordsTable.vue'
import { getStructureImageUrl, HAZARD_URL } from '@/main'

export default {
  components: { ScoreRecordsTable },

  props: {
    hazardName: {
      type: String,
      default: null,
    },
    scoreRecords: {
      type: [Array, null],
      default: null,
    },
    chemical: {
      type: [Object, null],
      default: null,
    },
    value: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      dialog: false,
      scoreRecords_: null,
      recordsTableFilter: null,
    }
  },

  computed: {
    getStructureImageUrl() {
      return getStructureImageUrl
    },
    records() {
      let result = this.scoreRecords ? this.scoreRecords : this.scoreRecords_
      if (this.recordsTableFilter) {
        result = result.filter((r) => {
          return Object.values(r)
            .filter((field) => field != null)
            .some((field) => field.toString().toLowerCase().includes(this.recordsTableFilter.toLowerCase()))
        })
      }
      return result
    },
  },

  watch: {
    value(val) {
      this.dialog = val
    },
    dialog(val) {
      this.$emit('input', val)
      if (val && !this.scoreRecords) {
        this.$axios.get(`${HAZARD_URL}?query=${encodeURIComponent(this.chemical.smiles)}`).then((response) => {
          const hazardChemical = response.data.hazardChemicals[0]
          this.scoreRecords_ = hazardChemical.scores.find((s) => s.hazardId === this.hazardName).records
        })
      }
    },
  },
}
</script>

<style scoped>
.records-table-filter {
  float: right;
  width: 400px;
  height: 1.5em;
  margin-bottom: 0 !important;
}
</style>
